module.exports = __webpack_public_path__ + "static/media/eige.78a067a2.m4a";